import styled, { css } from 'styled-components/macro';
import { getDSColor } from 'utils';
import { StyledSeparatorProps } from './separator.types';

export const StyledSeparator = styled.hr<StyledSeparatorProps>`
  ${({ theme, $vertical, $fill }) => css`
    ${$vertical
      ? css`
          min-width: 1px;
          min-height: 100%;
        `
      : css`
          width: 100%;
          min-height: 1px;
        `}

    margin: ${$vertical
      ? `0 ${theme.spacings.xxs} `
      : `${theme.spacings.xxs} 0 `};
    border: none;
    background-color: ${$fill === 'gray.200'
      ? theme.semantic.border.default
      : getDSColor(theme, $fill)};
  `}
`;
